'use client';

import { useMotionValueEvent, useScroll } from 'motion/react';
import Image from 'next/image';
import { useRef, useState } from 'react';

import { Carousel, CarouselSlide } from '@/components/carousel';
import { cn } from '@/utils/cn';

import { Gallery as GalleryType } from '../../types';

type Props = Pick<GalleryType, 'items'>;

export const Gallery = ({ items }: Props) => {
    const ref = useRef(null);
    const [, setIsInView] = useState(false);

    const { scrollYProgress } = useScroll({
        offset: ['start end', 'start start'],
        target: ref,
    });

    useMotionValueEvent(scrollYProgress, 'change', () => {
        const offsetStart = 0.4;
        const offsetEnd = 0;
        const value = Math.min(
            1,
            Number(Math.max(0, scrollYProgress.get() - offsetStart)) /
                (1 - offsetStart - offsetEnd),
        );

        setIsInView(value > 0 && value < 1);
    });

    return (
        <div ref={ref}>
            <Carousel
                controls={['circleArrows']}
                className="w-full"
                options={{ dragFree: true }}
            >
                {...items.map(
                    ({ assetProps, classNameRotation, source, title }) => (
                        <CarouselSlide key={source}>
                            <div className="my-10">
                                <Image
                                    className={cn(
                                        `
                                          rounded-[60px] transition-all
                                          duration-300

                                          hover:rounded-[20px]
                                        `,
                                        classNameRotation,
                                    )}
                                    src={source}
                                    alt={title}
                                    {...assetProps}
                                />
                            </div>
                        </CarouselSlide>
                    ),
                )}
            </Carousel>
        </div>
    );
};
